// src/services/api/offlineSales/cashierSessions.js
import { apiClient } from '../base';

export const getActiveSession = async (shopId) => {
  const params = shopId ? { shopId } : {};
  const response = await apiClient.get('/offline-sales/sessions/active', { params });
  return response.data;
};

// data: { shopId, cashierId, openingCash }
export const openSession = async (data) => {
  const response = await apiClient.post('/offline-sales/sessions/open', data);
  return response.data;
};

// data: { closingBreakdown: { cash, card, ... }, notes }
export const closeSession = async (sessionId, data) => {
  const response = await apiClient.put(`/offline-sales/sessions/${sessionId}/close`, data);
  return response.data;
};

export const getSessionReport = async (sessionId) => {
  const response = await apiClient.get(`/offline-sales/sessions/${sessionId}/report`);
  return response.data;
};

export const getSessions = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/sessions', { params });
  return response.data;
};

// Past cashier sessions of a shop a terminal sale can be backdated into, each with the days it covers
export const getBackdateSessions = async (shopId) => {
  const response = await apiClient.get('/offline-sales/sessions/backdate-options', { params: { shopId } });
  return response.data;
};

// Active "Shop Staff" users, used as cashier options when filtering by session
export const getSessionCashiers = async () => {
  const response = await apiClient.get('/offline-sales/sessions/cashiers');
  return response.data;
};
